"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../../Themes/styled-components"));
var InputSmarttag_1 = __importDefault(require("../InputSmarttag"));
// import { smarttagsPropType } from '../InputSmarttag/propTypes';
var SmarttagTags_1 = __importDefault(require("../SmarttagTags"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var SmarttagTagsWrapper = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), polished_1.rem(10));
var SmarttagControl = /** @class */ (function (_super) {
    __extends(SmarttagControl, _super);
    function SmarttagControl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SmarttagControl.prototype.render = function () {
        var _a = this.props, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, availableSmarttags = _a.availableSmarttags, getSmarttagsKeys = _a.getSmarttagsKeys, getSmarttagsValues = _a.getSmarttagsValues, readOnly = _a.readOnly, defaultInputValue = _a.defaultInputValue, restProps = __rest(_a, ["value", "onChange", "disabled", "availableSmarttags", "getSmarttagsKeys", "getSmarttagsValues", "readOnly", "defaultInputValue"]);
        return (React.createElement(Wrapper, null,
            !readOnly && (React.createElement(InputSmarttag_1.default, __assign({ disabled: disabled, defaultInputValue: defaultInputValue, onAdd: function (newSmarttag) {
                    var smarttags = __spreadArrays(value);
                    var smarttagIndex = smarttags.findIndex(function (stag) { return stag.key === newSmarttag.key; });
                    if (smarttagIndex === -1) {
                        // we don't have this smarttag group
                        smarttags.push(newSmarttag);
                    }
                    else {
                        var smarttag = __assign({}, smarttags[smarttagIndex]);
                        var idx = smarttag.values.findIndex(function (val) { return val.key === newSmarttag.values[0].key; });
                        if (idx === -1) {
                            smarttag.values = __spreadArrays(smarttag.values, [newSmarttag.values[0]]);
                        }
                        smarttags = __spreadArrays(smarttags.slice(0, smarttagIndex), [
                            smarttag
                        ], smarttags.slice(smarttagIndex + 1));
                    }
                    onChange(__spreadArrays(smarttags));
                }, availableSmarttags: availableSmarttags, getSmarttagsKeys: getSmarttagsKeys, getSmarttagsValues: getSmarttagsValues, readOnly: readOnly }, restProps))),
            React.createElement(SmarttagTagsWrapper, null,
                React.createElement(SmarttagTags_1.default, { onChange: readOnly
                        ? null
                        : function (newSmarttags) {
                            onChange(newSmarttags);
                        }, items: value, disabled: disabled }))));
    };
    SmarttagControl.defaultProps = {
        availableSmarttags: [],
        value: [],
        getSmarttagsKeys: null,
        getSmarttagsValues: null,
        onChange: function () { },
        readOnly: false,
        defaultInputValue: '',
        disabled: false,
    };
    return SmarttagControl;
}(React.Component));
// SmarttagControl.propTypes = {
//   availableSmarttags: smarttagsPropType,
//   getSmarttagsKeys: PropTypes.func,
//   getSmarttagsValues: PropTypes.func,
//   value: smarttagsPropType,
//   onChange: PropTypes.func,
//   readOnly: PropTypes.bool,
//   defaultInputValue: PropTypes.string,
//   disabled: PropTypes.bool,
// };
exports.default = SmarttagControl;
var templateObject_1, templateObject_2;
